import { combineReducers } from "redux";
import customers from "./customers/reducer";
import customer from "./customer/reducer";

export default combineReducers({
  customers,
  customer,
});
